import React, { useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import TW5030 from "../assets/products/inspectionControl/TW5030.jpg";
import TW6040 from "../assets/products/inspectionControl/TW6040.jpg";
import TW6550 from "../assets/products/inspectionControl/TWAT6550B.jpg";
import TW100100 from "../assets/products/inspectionControl/TW-100100.jpg";
import TW5030AI from "../assets/products/inspectionControl/TW5030AI.jpg";
import TW6040BAI from "../assets/products/inspectionControl/TW-6040BAI.jpg";
import phone from "../assets/icons/phone.png";
import whatsappIcon from "../assets/icons/whatsapp-icon.png";
import logo from "../assets/TimeWatchlogo.png";
import { MdCallMade } from "react-icons/md";
import "../styles/landing.css";
import LandingEnquiryForm from "./LandingEnquiryForm";
import ProductsData from "../data/products.json";
import { useParams } from "react-router";
import datasheet from "../assets/icons/download-datasheet.png";
import bannerGif from "../assets/images/Baggage-Banner.gif";

// console.log("ProductsData", ProductsData?.products);

const LandingBaggage = () => {
  const [productTitle, setProductTitle] = useState("");
  const { category, subcategory, product } = useParams();
  const [isFormVisible, setIsFormVisible] = useState(false);
  const handleCallClick = () => {
    window.location.href = "tel:+919210068047"; // Replace with your actual phone number
  };

  const handleWhatsappClick = () => {
    window.open("https://wa.me/919210068047", "_blank");
  };

  const handleBookNow = (product) => {
    setProductTitle(product);
    // console.log("product", product);
    setIsFormVisible(true);
  };

  const handleOpenForm = () => setIsFormVisible(true);
  const handleCloseForm = () => setIsFormVisible(false);

  console.log("ProductsData?.products", ProductsData?.products);

  const filteredProducts = ProductsData?.products
  ?.flatMap((card) => card.subCategories)
  ?.filter((sub) => sub.subCategoryName === "X-Ray Baggage Scanner")
  ?.flatMap((sub) => sub.products || []);

// Separate into two lists
const withPriority = filteredProducts
  ?.filter((item) => typeof item.priority === "number")
  ?.sort((a, b) => a.priority - b.priority);

const withoutPriority = filteredProducts
  ?.filter((item) => typeof item.priority !== "number");

// Combine
const finalList = [...withPriority, ...withoutPriority];

  return (
    <>
      <nav className="navbar navbar-light bg-light justify-content-between px-1 px-md-4 baggage-nav">
        <a className="navbar-brand">
          <img
            src={logo}
            className="d-inline-block align-top img-fluid"
            alt="Logo"
            style={{ width: "240px", height: "60px" }}
          />
        </a>
        <div className="d-flex" style={{ gap: "10px" }}>
          <button
            className="btn shadow d-flex align-items-center justify-content-md-between px-3 py-2 custom-btn"
            onClick={handleCallClick}
            style={{
              backgroundColor: "#415BF1",
              borderRadius: "100px",
            }}
          >
            <img src={phone} width={30} className="m-auto" />
            <div className="d-none d-sm-flex flex-column text-start ms-2">
              <span className="fw-bold text-white">Call Us</span>
            </div>
          </button>
          <button
            className="btn shadow d-flex align-items-center justify-content-md-between px-3 py-2 custom-btn"
            onClick={handleWhatsappClick}
            style={{
              backgroundColor: "#25D366",
              borderRadius: "100px",
            }}
          >
            <img src={whatsappIcon} width={30} className="m-auto" />
            <div className="d-none d-sm-flex flex-column text-start ms-2">
              <span className="fw-bold text-white">Whatsapp</span>
            </div>
          </button>
        </div>
      </nav>

      <header style={{ paddingLeft: 0 }}>
        <div
          className="text-center bg-image"
          // style={{
          //   backgroundImage: "url('https://api.mytimewatch.com/banners/4.jpg')",
          //   minHeight: 600, // Adjusted to make it more flexible
          //   width: "100%",
          //   backgroundSize: "cover",
          //   backgroundPosition: "center", // Ensures the center stays visible
          //   backgroundRepeat: "no-repeat",
          // }}
        >
               <img src={bannerGif} className="w-100"/>
          {/* <div
            className="mask"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
          >
            <div className="d-flex justify-content-center align-items-center h-100">
              <div className="text-white">
                <h1 className="mb-3">Heading</h1>
                <h4 className="mb-3">Subheading</h4>
                <a
                  className="btn btn-outline-light btn-lg"
                  href="#!"
                  role="button"
                >
                  Call to action
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </header>
      <div
        className="p-4 row row-cols-1 row-cols-sm-2 row-cols-md-3 justify-content-center custom-row mt-5"
        style={{ gap: "10rem" }}
      >
        {finalList?.map((item) => {
          return (
            <Card
              style={{
                width: "25rem",
                backgroundColor: "white",
                border: "2px solid rgba(0, 0, 0, 0.1)",
              }}
            >
              {
                console.log("item", item)
              }
              <div className="d-flex justify-content-end w-100">
                <div
                  className="d-flex justify-content-end"
                  style={{ gap: "20px" }}
                >
                  <button
                    className="btn shadow d-flex align-items-center  justify-content-center px-4 py-2 w-100"
                    onClick={() => handleBookNow(item?.productName)}
                    style={{
                      backgroundColor: "#415BF1",
                      borderRadius: "100px",
                    }}
                  >
                    <MdCallMade
                      className="text-white"
                      style={{ width: "35px", height: "35px" }}
                    />
                    <div className="d-flex flex-column text-start ms-2">
                      <span className="fw-bold text-white">Book Now</span>
                    </div>
                  </button>
                </div>
              </div>
              <Card.Img
                variant="top"
                src={require(`../assets/products/${item.productimg}`)}
              />
              <Card.Body>
                <Card.Title className="text-black">
                  {item?.productName}
                </Card.Title>
                <Card.Text className="text-black">
                  {item?.description}
                </Card.Text>
                <div className="product-files">
                  <div className="row d-flex justify-content-center">
                    <div className="d-flex justify-content-center mb-3">
                      <a
                        href={item?.files[0]?.Datasheet?.link}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {/* {console.log("item?.files", item?.files)} */}
                        <img
                          src="/assets/icons/download-datasheet.png"
                          alt="Download Datasheet"
                          className="img-fluid file-icon"
                          style={{
                            width: "100px",
                            height: "auto",
                            marginRight: "15px",
                            marginLeft: "15px",
                          }}
                        />
                      </a>

                      <a
                        href={item?.files?.[0]?.["User Manual"]?.link || "#"}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <img
                          src="/assets/icons/download-usermanual.png"
                          alt="Download User Manual"
                          className="img-fluid file-icon"
                          style={{
                            width: "100px",
                            height: "auto",
                            marginRight: "15px",
                            marginLeft: "15px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="product-files">
                  <div className="row d-flex justify-content-center">
                    <div
                      className="d-flex justify-content-center mb-0 custom-gap"
                      style={{ gap: "20px" }}
                    >
                      <button
                        className="btn shadow d-flex align-items-center  justify-content-between px-4 py-2 custom-btn"
                        onClick={handleCallClick}
                        style={{
                          backgroundColor: "#415BF1",
                          borderRadius: "100px",
                        }}
                      >
                        <i className="bi fs-4 text-primary">
                          <img src={phone} width={30} />
                        </i>
                        <div className="d-flex flex-column text-start ms-2 d-none d-md-block">
                          <span className="fw-bold text-white">Call Us</span>
                        </div>
                      </button>

                      <button
                        className="btn shadow d-flex align-items-center justify-content-between px-4 py-2 custom-btn"
                        onClick={handleWhatsappClick}
                        target="_blank"
                        rel="noopenner noreferrer"
                        style={{
                          backgroundColor: "#25D366",
                          borderRadius: "100px",
                        }}
                      >
                        <i className="bi fs-4 text-primary">
                          <img src={whatsappIcon} width={30} />
                        </i>
                        <div className="d-flex flex-column text-start ms-2  d-none d-md-block">
                          <span className="fw-bold text-white">Whatsapp</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          );
        })}
      </div>

      {isFormVisible && (
        <LandingEnquiryForm
          productTitle={productTitle}
          onClose={handleCloseForm}
        />
      )}
    </>
  );
};

export default LandingBaggage;
